import React from 'react';

import {exportAuditLogs} from 'audit/AuditActions';
import {EXPORT_AUDIT_LOG_DISPLAY_STRING} from 'audit/AuditConstants';
import {doQuerySafe} from 'graphql-client/ApolloWrappers';
import SettingsIconDropdown from 'nav/sidepanel/SettingsIconDropdown';
import SettingsIcon from 'ui-library/icons/SettingsIcon';
import runModal from 'ui-library/runModal';
import {
  WorklistSettingsOwnerAndCollaboratorsQuery,
  WorklistSettingsOwnerAndCollaboratorsQueryVariables,
} from 'worklists/__generated/WorklistSettingsOwnerAndCollaboratorsQuery';
import ReorderWorklistModal from 'worklists/ReorderWorklistModal';
import WorklistSettingsModal, {
  WORKLIST_SETTINGS_OWNER_AND_COLLABORATORS_QUERY,
} from 'worklists/WorklistSettingsModal';

import {WorklistSummaryGraphQL} from '../../graphql-fragments/worklists/__generated/WorklistSummaryGraphQL';

interface Props {
  worklist: WorklistSummaryGraphQL | null;
  itemIds: Array<string> | null;
}

function handleOpenReorderModal(worklist: WorklistSummaryGraphQL, itemIds: Array<string>): void {
  runModal(ReorderWorklistModal, {worklist, itemIds});
}

function handleEditWithCollaboratorsModal(worklist: WorklistSummaryGraphQL): void {
  runModal(WorklistSettingsModal, {worklistId: worklist.id});
}

function handleExportAuditLog(worklist: WorklistSummaryGraphQL): void {
  exportAuditLogs([worklist.id]);
}

export default function WorklistSettingIcon({worklist, itemIds}: Props): JSX.Element {
  if (worklist && itemIds) {
    const options = [
      {
        name: 'Worklist settings',
        handleOnClick: () => {
          handleEditWithCollaboratorsModal(worklist);
        },
      },
      {
        name: 'Worklist order',
        handleOnClick: () => {
          handleOpenReorderModal(worklist, itemIds);
        },
      },
      {
        name: EXPORT_AUDIT_LOG_DISPLAY_STRING,
        handleOnClick: () => {
          handleExportAuditLog(worklist);
        },
      },
    ];

    return (
      <SettingsIconDropdown
        options={[options]}
        // Pre-fetch owner and collaborator data so user does not have to wait for it to load upon opening
        // the WorklistSettingsModal
        onClick={() =>
          doQuerySafe<
            WorklistSettingsOwnerAndCollaboratorsQuery,
            WorklistSettingsOwnerAndCollaboratorsQueryVariables
          >(
            {query: WORKLIST_SETTINGS_OWNER_AND_COLLABORATORS_QUERY},
            {
              variables: {worklistId: worklist.id},
            }
          )
        }
      />
    );
  } else {
    return <SettingsIcon className="u-tiny-spacing-left faded" />;
  }
}
